import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateConditionParams {
  custom_tag_id: number;
  id: number;
  condition_column: string;
  condition_content: string;
  condition_type: string;
}

/**
 * 求職者タグ条件を更新するフック
 * エンドポイントは求人タグと共通（tag_type 非依存）
 */
export default function useUpdateTagCondition() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (params: UpdateConditionParams) => {
      const { custom_tag_id, id, ...conditionData } = params;
      const response = await fetch(`/agent/api/custom_tags/${custom_tag_id}/conditions/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          custom_tag_condition: conditionData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update condition');
      }

      return response.json();
    },
    onSuccess: (_, variables) => {
      // 条件一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/custom_tags', variables.custom_tag_id, 'conditions'],
      });
    },
  });
}
